import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SelectField } from "@/lib/crm";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { DocumentsPanel } from "@/components/documents/DocumentsPanel";

// Condizioni Generali (versione congelata sulla revisione) + PDF server-side archiviato + documenti della revisione
export const QuoteDocs = ({ q, onDone }) => {
  const { can } = useAuth();
  const [cg, setCg] = useState([]);
  const [k, setK] = useState(0);
  const draft = q.status === "bozza" && can("quotes:update");
  useEffect(() => {
    if (draft && can("documents:read")) api.get("/documents", { params: { category: "condizioni_generali" } })
      .then((r) => setCg(r.data.items.filter((d) => !d.company_id).map((d) => ({ key: d.id, label: `${d.title} (v${d.current_version})` })))).catch(() => {});
  }, [draft, can]);
  const setTerms = async (id) => {
    try { await api.put(`/sales/quotes/${q.id}/general-terms`, { document_id: id || null }); toast.success("Condizioni Generali aggiornate"); onDone(); } catch (e) { toast.error(errorMessage(e)); }
  };
  const archive = async () => {
    try { const r = await api.post(`/sales/quotes/${q.id}/pdf/archive`); toast.success(r.data.unchanged ? `PDF già archiviato (${r.data.number})` : `PDF archiviato: ${r.data.number} v${r.data.version}`); setK((x) => x + 1); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  const gt = q.general_terms;
  return (
    <Panel className="mt-6 p-5" data-testid="quote-docs">
      <div className="mb-4 flex flex-wrap items-end gap-3 border-b border-line pb-4">
        <div className="min-w-0 flex-1"><SectionLabel>Condizioni Generali</SectionLabel>
          <p className="mt-1 text-sm text-ink" data-testid="quote-general-terms">{gt ? `${gt.title} · ${gt.number} v${gt.version}` : "Nessuna applicata"}</p>
          {!draft && gt && <p className="text-xs text-slate-500">Versione congelata su questa revisione.</p>}</div>
        {draft && <SelectField value={gt?.document_id || ""} onChange={setTerms} options={cg} allowNone="Nessuna" className="w-64" testId="quote-general-terms-select" />}
        {can("documents:create") && !["annullata", "revisionata"].includes(q.status) && <Button variant="outline" onClick={archive} data-testid="quote-pdf-archive">Archivia PDF revisione</Button>}
      </div>
      <DocumentsPanel key={k} entityType="quote" entityId={q.id} bare />
    </Panel>
  );
};
